export default __webpack_public_path__ + "static/media/47bc977d8044df12.a143f916aac9672546f59a18884d335b.svg";